import { NL } from "./ui-nl";

export const FR = {
  // Cookie banner
  "Your privacy at ESAIA": "Votre vie privée chez ESAIA",
  "ESAIA uses only strictly necessary cookies to keep this website secure and your session active. We do not use advertising or tracking cookies. Read our": "ESAIA utilise uniquement des cookies strictement nécessaires pour sécuriser ce site et maintenir votre session active. Nous n'utilisons aucun cookie publicitaire ou de suivi. Lisez notre",
  "Cookie Policy": "Politique relative aux cookies",
  "Decline": "Refuser",
  "Accept": "Accepter",

  // Auth
  "ESAIA Portal": "Portail ESAIA",
  "Back to website": "Retour au site",
  "Transparent. Accountable. Ethical.": "Transparent. Responsable. Éthique.",
  "Login": "Connexion",
  "Log in": "Se connecter",
  "Log out": "Se déconnecter",
  "Sign in to your ESAIA portal.": "Connectez-vous à votre portail ESAIA.",
  "Email": "E-mail",
  "Password": "Mot de passe",
  "Log In": "Se connecter",
  "Signing in...": "Connexion en cours...",
  "Forgot Password?": "Mot de passe oublié ?",
  "Create Account": "Créer un compte",
  "Create your ESAIA Account": "Créez votre compte ESAIA",
  "Access your assessments, reports and certificates in the Client Portal.": "Accédez à vos évaluations, rapports et certificats dans le portail client.",
  "First name": "Prénom",
  "Last name": "Nom",
  "Company": "Entreprise",
  "Job title": "Fonction",
  "Country": "Pays",
  "Phone number": "Numéro de téléphone",
  "Confirm password": "Confirmer le mot de passe",
  "Minimum 8 characters, with a letter and a number.": "Minimum 8 caractères, avec une lettre et un chiffre.",
  "I agree to the": "J'accepte les",
  "ESAIA Terms": "conditions ESAIA",
  "and": "et la",
  "Privacy Policy": "Politique de confidentialité",
  "Creating account...": "Création du compte...",
  "Already have an account?": "Vous avez déjà un compte ?",
  "Your ESAIA account has been created.": "Votre compte ESAIA a été créé.",
  "Forgot your password?": "Mot de passe oublié ?",
  "Enter your email address and we'll send you a secure link to reset your password.": "Saisissez votre adresse e-mail et nous vous enverrons un lien sécurisé pour réinitialiser votre mot de passe.",
  "Send Reset Link": "Envoyer le lien",
  "Sending...": "Envoi en cours...",
  "If an account exists for this email address, you will receive a password reset link.": "Si un compte existe pour cette adresse e-mail, vous recevrez un lien de réinitialisation.",
  "Return to Login": "Retour à la connexion",
  "Reset Password": "Réinitialiser le mot de passe",
  "Choose a new password for your ESAIA account.": "Choisissez un nouveau mot de passe pour votre compte ESAIA.",
  "New password": "Nouveau mot de passe",
  "Confirm new password": "Confirmer le nouveau mot de passe",
  "Updating...": "Mise à jour...",
  "Your password has been updated successfully.": "Votre mot de passe a été mis à jour avec succès.",
  "This reset link is missing its token. Please use the link from your email.": "Ce lien de réinitialisation ne contient pas de jeton. Utilisez le lien de votre e-mail.",
  "Change Password": "Changer le mot de passe",
  "Update the password of your ESAIA account.": "Modifiez le mot de passe de votre compte ESAIA.",
  "For security reasons, you must create a new password before continuing.": "Pour des raisons de sécurité, vous devez créer un nouveau mot de passe avant de continuer.",
  "Current password": "Mot de passe actuel",
  "Password successfully updated.": "Mot de passe mis à jour avec succès.",
  "Something went wrong. Please try again.": "Une erreur s'est produite. Veuillez réessayer.",
  "Invalid email or password.": "E-mail ou mot de passe invalide.",
  "Your session has expired. Please log in again.": "Votre session a expiré. Veuillez vous reconnecter.",
  "You do not have permission to access this resource.": "Vous n'avez pas la permission d'accéder à cette ressource.",
  "My Portal": "Mon portail",

  // Client portal
  "Client Portal": "Portail client",
  "Dashboard": "Tableau de bord",
  "Assessments": "Évaluations",
  "Certificates": "Certificats",
  "Request a Service": "Demander un service",
  "Account": "Compte",
  "Help": "Aide",
  "Log Out": "Se déconnecter",
  "Loading...": "Chargement...",
  "Welcome,": "Bienvenue,",
  "Active Assessments": "Évaluations actives",
  "Completed Assessments": "Évaluations terminées",
  "Latest Updates": "Dernières mises à jour",
  "No updates yet.": "Pas encore de mises à jour.",
  "My Assessments": "Mes évaluations",
  "All ESAIA assessments and ERI results for your organization.": "Toutes les évaluations ESAIA et les résultats ERI de votre organisation.",
  "No assessments yet.": "Pas encore d'évaluations.",
  "Start:": "Début :",
  "Completed": "Terminé",
  "Score": "Score",
  "Back to Assessments": "Retour aux évaluations",
  "Start Date": "Date de début",
  "Completion Date": "Date d'achèvement",
  "Last Updated": "Dernière mise à jour",
  "Assessment ID": "ID d'évaluation",
  "Assessment Summary": "Résumé de l'évaluation",
  "ERI Results": "Résultats ERI",
  "Key Findings": "Constatations clés",
  "Risk Summary": "Résumé des risques",
  "Recommendations": "Recommandations",
  "Management Summary": "Résumé pour la direction",
  "Additional Notes": "Notes complémentaires",
  "Assessment Progress": "Progression de l'évaluation",
  "Management Reports": "Rapports de gestion",
  "No management reports have been uploaded for this assessment.": "Aucun rapport de gestion n'a encore été téléchargé pour cette évaluation.",
  "View": "Voir",
  "Download": "Télécharger",
  "ERI Result": "Résultat ERI",
  "Key Attention Areas": "Points d'attention clés",
  "My Certificates": "Mes certificats",
  "Your complete ESAIA certification history. Expired certificates remain visible for reference.": "Votre historique complet de certification ESAIA. Les certificats expirés restent visibles à titre de référence.",
  "No certificates have been uploaded yet.": "Aucun certificat n'a encore été téléchargé.",
  "Certificate:": "Certificat :",
  "View Certificate": "Voir le certificat",
  "Download PDF": "Télécharger le PDF",
  "Request an ESAIA Service": "Demander un service ESAIA",
  "Select a service below. ESAIA will review your request and open an assessment.": "Sélectionnez un service ci-dessous. ESAIA examinera votre demande et ouvrira une évaluation.",
  "Free initial AI readiness assessment.": "Évaluation initiale gratuite de préparation à l'IA.",
  "Start ERI": "Démarrer le ERI",
  "For organizations with 1 to 10 legal entities.": "Pour les organisations de 1 à 10 entités juridiques.",
  "Request Certification": "Demander la certification",
  "For organizations with more than 10 entities or large/complex structures.": "Pour les organisations de plus de 10 entités ou les structures grandes/complexes.",
  "Request Group-Wide Assessment": "Demander une évaluation Group-Wide",
  "Annual Recertification": "Recertification annuelle",
  "For existing ESAIA-certified organizations.": "Pour les organisations déjà certifiées ESAIA.",
  "Request Recertification": "Demander la recertification",
  "My Service Requests": "Mes demandes de service",
  "No service requests yet.": "Pas encore de demandes de service.",
  "Add a short message for the ESAIA team (optional).": "Ajoutez un court message pour l'équipe ESAIA (facultatif).",
  "Context, number of entities, timelines...": "Contexte, nombre d'entités, délais...",
  "Submit Request": "Envoyer la demande",
  "Submitting...": "Envoi en cours...",
  "Your service request has been submitted.": "Votre demande de service a été envoyée.",
  "My Account": "Mon compte",
  "Account created": "Compte créé le",
  "Profile Information": "Informations du profil",
  "Save Changes": "Enregistrer",
  "Saving...": "Enregistrement...",
  "Security": "Sécurité",
  "Your account information has been updated.": "Vos informations de compte ont été mises à jour.",
  "Phone": "Téléphone",

  // Statuses
  "ACTIVE": "ACTIF",
  "COMPLETED": "TERMINÉ",
  "PENDING": "EN ATTENTE",
  "EXPIRED": "EXPIRÉ",
  "Requested": "Demandé",
  "Under Review": "En cours d'examen",
  "Active": "Actif",
  "Declined": "Refusé",
  "Valid": "Valide",
  "Expired": "Expiré",
  "Not found": "Introuvable",

  // Admin portal
  "Admin Portal": "Portail admin",
  "ERI": "ERI",
  "Mail": "Courrier",
  "Clients": "Clients",
  "Administrator": "Administrateur",
  "ERI Submissions": "Soumissions ERI",
  "Every completed Ethical Readiness Index, newest first.": "Chaque Ethical Readiness Index complété, le plus récent d'abord.",
  "Search name, company, email": "Rechercher nom, entreprise, e-mail",
  "All": "Tous",
  "Attention required": "Attention requise",
  "Developing": "En développement",
  "Established": "Établi",
  "Name": "Nom",
  "Date": "Date",
  "Readiness": "Préparation",
  "Client": "Client",
  "Linked": "Lié",
  "Not linked": "Non lié",
  "No ERI submissions yet.": "Pas encore de soumissions ERI.",
  "Previous": "Précédent",
  "Next": "Suivant",
  "Page": "Page",
  "of": "sur",
  "Back to ERI Submissions": "Retour aux soumissions ERI",
  "Contact Information": "Coordonnées",
  "Date completed": "Date d'achèvement",
  "Client Link": "Lien client",
  "Linked to": "Lié à",
  "Not linked to a client account.": "Non lié à un compte client.",
  "Select client...": "Sélectionner un client...",
  "Link to Client": "Lier au client",
  "Update Link": "Mettre à jour le lien",
  "Submission updated.": "Soumission mise à jour.",
  "Risk indicators": "Indicateurs de risque",
  "Answers": "Réponses",
  "Detailed answers are available for submissions completed after the portal launch.": "Les réponses détaillées sont disponibles pour les soumissions complétées après le lancement du portail.",
  "Question": "Question",
  "Answer:": "Réponse :",
  "Communications received through ESAIA for info@esaia.org.": "Communications reçues via ESAIA pour info@esaia.org.",
  "unread.": "non lu(s).",
  "Inbox": "Boîte de réception",
  "Unread": "Non lus",
  "Archive": "Archives",
  "Search sender or subject": "Rechercher expéditeur ou sujet",
  "No emails yet.": "Pas encore d'e-mails.",
  "Select an email to read it.": "Sélectionnez un e-mail pour le lire.",
  "From:": "De :",
  "Client linked": "Client lié",
  "Mark as Unread": "Marquer comme non lu",
  "Mark as Read": "Marquer comme lu",
  "Restore": "Restaurer",
  "Link to client...": "Lier à un client...",
  "Marked as unread.": "Marqué comme non lu.",
  "Marked as read.": "Marqué comme lu.",
  "Archived.": "Archivé.",
  "Restored to inbox.": "Restauré dans la boîte de réception.",
  "Client link updated.": "Lien client mis à jour.",
  "Every registered client organization.": "Chaque organisation cliente enregistrée.",
  "Latest activity": "Dernière activité",
  "Status": "Statut",
  "No clients registered yet.": "Pas encore de clients enregistrés.",
  "Back to Clients": "Retour aux clients",
  "Client Information": "Informations client",
  "Account created:": "Compte créé le :",
  "Client information updated.": "Informations client mises à jour.",
  "ERI History": "Historique ERI",
  "No ERI submissions linked to this client.": "Aucune soumission ERI liée à ce client.",
  "Related Emails": "E-mails associés",
  "No emails linked to this client.": "Aucun e-mail lié à ce client.",
  "Add Assessment": "Ajouter une évaluation",
  "Type": "Type",
  "Updated": "Mis à jour",
  "Create a new assessment for": "Créer une nouvelle évaluation pour",
  "Assessment type": "Type d'évaluation",
  "Start date": "Date de début",
  "Target completion": "Achèvement cible",
  "Internal notes": "Notes internes",
  "Create Assessment": "Créer l'évaluation",
  "Assessment created.": "Évaluation créée.",
  "Service Requests": "Demandes de service",
  "No service requests.": "Aucune demande de service.",
  "Request status updated.": "Statut de la demande mis à jour.",
  "Back to": "Retour à",
  "Internal notes (never shown to the client)": "Notes internes (jamais visibles par le client)",
  "Assessment updated.": "Évaluation mise à jour.",
  "Assessment Activities": "Activités de l'évaluation",
  "Upload PDF Report": "Télécharger un rapport PDF",
  "Management report uploaded.": "Rapport de gestion téléchargé.",
  "Report deleted.": "Rapport supprimé.",
  "Assessment Summary (publish per field to the client portal)": "Résumé de l'évaluation (publier par champ vers le portail client)",
  "Visible to client": "Visible par le client",
  "Summaries saved.": "Résumés enregistrés.",
  "Upload Certificate (PDF)": "Télécharger un certificat (PDF)",
  "Certificate Number": "Numéro de certificat",
  "Certification type": "Type de certification",
  "Expiry date": "Date d'expiration",
  "Status (automatic by expiry date; override only if needed)": "Statut (automatique selon la date d'expiration ; remplacer uniquement si nécessaire)",
  "Automatic": "Automatique",
  "Force ACTIVE": "Forcer ACTIF",
  "Force EXPIRED": "Forcer EXPIRÉ",
  "Upload Certificate": "Télécharger le certificat",
  "Certificate uploaded.": "Certificat téléchargé.",
  "Certificate updated.": "Certificat mis à jour.",
  "Certificate deleted.": "Certificat supprimé.",
  "uploaded": "téléchargé le",
  "Please select a certificate PDF.": "Veuillez sélectionner un PDF de certificat.",

  // Checklist
  "Scope defined": "Périmètre défini",
  "AI environment reviewed": "Environnement IA examiné",
  "AI systems identified": "Systèmes IA identifiés",
  "AI agents identified": "Agents IA identifiés",
  "Governance reviewed": "Gouvernance examinée",
  "Risk assessment completed": "Évaluation des risques terminée",
  "Documentation reviewed": "Documentation examinée",
  "Human oversight reviewed": "Supervision humaine examinée",
  "Transparency reviewed": "Transparence examinée",
  "Accountability reviewed": "Responsabilité examinée",
  "Findings documented": "Constatations documentées",
  "Recommendations completed": "Recommandations terminées",
  "Management report uploaded": "Rapport de gestion téléchargé",
  "Certification decision completed": "Décision de certification terminée",

  // Reference marker so unused-import linters stay quiet
  __base: Object.keys(NL).length,
};
